import { render, staticRenderFns } from "./lista-v3.vue?vue&type=template&id=079837d5&scoped=true"
import script from "./lista-v3.vue?vue&type=script&lang=js"
export * from "./lista-v3.vue?vue&type=script&lang=js"
import style0 from "./lista-v3.vue?vue&type=style&index=0&id=079837d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079837d5",
  null
  
)

export default component.exports